import declare from "dojo/_base/declare";
import reflection from "csi/reflection";
import lang from "dojo/_base/lang";
import Widget from "csi/table/Widget";
import AddPath from "csi/def/AddPath";

const ProductColors = declare(Widget, {
	buildProductColorsView: function(view, isAllocated, rc) {
		view.m_depPaths = ["Child:Parent/Child:Theme/Child:ColorColorways"];
		const relationship = view.m_relationships[0];
		if (isAllocated) {
			relationship.m_rcTarget = rc;
			relationship.m_addPaths = [lang.mixin(new AddPath(), {
				m_path: "Child:ForProductSource/Child:ColorSources/Child:Colorway",
			})];
			relationship.m_target = "Colorway";
		} else {
			relationship.m_addPaths = [lang.mixin(new AddPath(), {
				m_path: "Child:__Parent__/Child:ProductColors",
			})];
			relationship.m_id = "ProductColors";
		}
		view.m_relationships = [relationship];
		return view;
	},

	onViewStartBuild: function() {
		const rc = reflection.getClass("Colorway");
		const ctx = this.getContext();
		let isAllocated = false;
		let product = this.getViewNode();
		if (product?.$Type === "DataPackage") {
			product = ctx.cache.getNode(product.__Parent__);
		}
		const view = this.defView;
		if (view.m_id === "ProductColorsWithColorAllocation" && product.ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP") {
			isAllocated = true;
		}
		this.buildProductColorsView(view, isAllocated, rc);
	},
});

export = ProductColors;
